<app-guest-container [isShowLanguageSelector]="!isLoading()">
  <div class="title">
    <h1 i18n="@@shared.newpassword">New password</h1>
  </div>

  @if (isLoading()) {
    <app-loader containerClass="no-margin"></app-loader>
  } @else {
    <div class="subtitle" i18n="@@reset-password.help">Set up your new password below.</div>

    <form (ngSubmit)="onSubmit()" [formGroup]="formGroup" class="flex-column">
      <app-input-password
        [label]="translations.passwordLabel"
        formControlName="password"
        showRequirementsTooltip
        autofocus
        autocomplete="new-password"
      ></app-input-password>

      <app-input-password
        [label]="translations.confirmPasswordLabel"
        formControlName="confirmPassword"
        class="no-padding mt-neg-12"
        autocomplete="new-password"
      ></app-input-password>
      <app-form-hint
        [errors]="formGroup.errors"
        [showError]="hasGroupValidationErrors"
      ></app-form-hint>

      <div class="submit-button">
        <app-button
          [disabled]="isSubmitButtonDisabled"
          class="fresh-green"
          accessibilityRole="submit"
          size="large"
          i18n="@@reset-password.setnew"
        >
          Set new password
        </app-button>
      </div>
    </form>

    <div class="switch-mode-container">
      <ng-container i18n="@@shared.backto">Back to</ng-container>
      <a [routerLink]="'/' + routingEnum.LOGIN" i18n="@@action.login">Login</a>
    </div>
  }
</app-guest-container>
